import { render, staticRenderFns } from "./bookcategories.vue?vue&type=template&id=fa06545a&"
import script from "./bookcategories.vue?vue&type=script&lang=js&"
export * from "./bookcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports